import React from 'react';

import { Icon, IconTypes } from '@eika/icon';

import { Warnings } from '../warnings/warning-types';

interface Props {
    warnings: Warnings;
}

type WarningKeys = keyof Warnings;

const FileValidation = ({ warnings }: Props) => {
    const activateWarnings = (warnings: Warnings) => {
        return Object.keys(warnings)
            .map((warningType) => warningType as WarningKeys)
            .filter((warningType) => warnings[warningType].fileName.length > 0)
            .map((warningType) => warnings[warningType]);
    };

    const activeWarnings = activateWarnings(warnings);

    return (
        <>
            {activeWarnings.length > 0 && (
                <div className="file-uploader--warning">
                    <span className="sgw-label error" role="alert">
                        <Icon type={IconTypes.UTROPSTEGN_24} />
                        <span>
                            <span className="file-uploader--warning-header">
                                Følgende feil skjedde under opplasting av filer:
                            </span>
                            <ul className="file-uploader--warning-list">
                                {activeWarnings.map((warning) => (
                                    <li
                                        className="file-uploader--warning-list_item"
                                        key={warning.fileName.join() + warning.warningText}
                                    >
                                        {warning.warningText(warning.fileName)}
                                    </li>
                                ))}
                            </ul>
                        </span>
                    </span>
                </div>
            )}
        </>
    );
};

export default FileValidation;
